interface WidgetContactItemProps {
  label: string;
  title: string;
  tel1?: string | null;
  tel2?: string | null;
  visible?: boolean;
}

const WidgetContactItem: React.FC<WidgetContactItemProps> = ({
  label,
  title,
  tel1,
  tel2,
  visible = true,
}) => {
  if (!visible || (!tel1 && !tel2)) return null;

  return (
    <div className="mb-3">
      <div>
        <h6>{label}</h6>
        <p className="mb-0">
          {tel1 && (
            <a href={`tel:${tel1}`} title={title}>
              {tel1}
            </a>
          )}
          {tel2 && (
            <>
              {"    "}
              <a href={`tel:${tel2}`} title={title}>
                {tel2}
              </a>
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default WidgetContactItem;